<div class="page">
  <div class="page-header">
    <div>
      <h1>{{ 'SUBJECTS.TITLE' | translate }}</h1>
      <p class="page-subtitle">{{ 'SUBJECTS.SUBTITLE' | translate }}</p>
    </div>
    <div class="page-actions">
      <button type="button" class="btn btn-primary" *appAccess="'subjects:add'" (click)="onAdd()">
        <mat-icon>add</mat-icon>
        {{ 'SUBJECTS.ADD' | translate }}
      </button>
    </div>
  </div>

  <div class="card">
    <div class="table-toolbar">
      <div class="table-toolbar-left">
        <input
          type="search"
          class="search-input"
          [placeholder]="'SUBJECTS.SEARCH' | translate"
          [(ngModel)]="searchTerm"
          (ngModelChange)="onSearchChange()"
        />
        <span class="selection-badge" *ngIf="selected.length">
          {{ selected.length }} {{ 'COMMON.SELECTED' | translate }}
        </span>
      </div>
      <div class="table-toolbar-right">
        <button type="button" class="btn btn-secondary btn-sm" *ngIf="selected.length" (click)="clearSelection()">
          {{ 'COMMON.CLEAR' | translate }}
        </button>
        <ng-container *appAccess="'subjects:edit'">
          <button type="button" class="btn btn-secondary btn-sm" *ngIf="selected.length === 1" (click)="onEdit()">
            {{ 'COMMON.EDIT' | translate }}
          </button>
        </ng-container>
        <ng-container *appAccess="'subjects:delete'">
          <button type="button" class="btn btn-danger btn-sm" *ngIf="selected.length" (click)="onDeleteMany()">
            {{ 'COMMON.DELETE' | translate }}
          </button>
        </ng-container>
      </div>
    </div>

    <div class="table-scroll">
      <table class="data-table" *ngIf="paginatedItems.length; else emptySubjects">
        <thead>
          <tr>
            <th style="width: 44px;"></th>
            <th>{{ 'COMMON.NAME' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of paginatedItems" class="clickable" [class.selected]="isSelected(item)" (click)="openRow(item)">
            <td>
              <input type="checkbox" [checked]="isSelected(item)" (change)="toggleSelection(item, $event)" />
            </td>
            <td>{{ item.name }}</td>
          </tr>
        </tbody>
      </table>
      <ng-template #emptySubjects>
        <div class="empty-state">{{ 'SUBJECTS.EMPTY' | translate }}</div>
      </ng-template>
    </div>

    <div class="table-footer">
      <div class="paginator">
        <span>{{ 'COMMON.ROWS_PER_PAGE' | translate }}</span>
        <select [(ngModel)]="pageSize" (ngModelChange)="onPageSizeChange($event)">
          <option *ngFor="let size of pageSizeOptions" [ngValue]="size">{{ size }}</option>
        </select>
        <span>{{ pageStart }}–{{ pageEnd }} {{ 'COMMON.OF' | translate }} {{ filteredItems.length }}</span>
      </div>
      <div class="page-actions">
        <button type="button" class="btn btn-secondary btn-sm" (click)="previousPage()" [disabled]="pageIndex === 0">
          {{ 'COMMON.PREVIOUS' | translate }}
        </button>
        <button type="button" class="btn btn-secondary btn-sm" (click)="nextPage()" [disabled]="pageIndex >= totalPages - 1">
          {{ 'COMMON.NEXT' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

<div class="modal-backdrop" *ngIf="showDeleteModal">
  <div class="modal-panel" role="dialog" aria-modal="true">
    <div class="modal-header"><h3>{{ 'COMMON.CONFIRM_DELETE' | translate }}</h3></div>
    <div class="modal-body"><p>{{ deleteModalBody | translate: deleteModalParams }}</p></div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="onDeleteConfirm(false)">
        {{ 'COMMON.CANCEL' | translate }}
      </button>
      <button type="button" class="btn btn-danger" (click)="onDeleteConfirm(true)">
        {{ 'COMMON.DELETE' | translate }}
      </button>
    </div>
  </div>
</div>

<div class="modal-backdrop" *ngIf="open">
  <div class="modal-panel" role="dialog" aria-modal="true">
    <div class="modal-header">
      <h3>{{ mode === 'view' ? (form.get('name')?.value || ('SUBJECTS.TITLE' | translate)) : ((mode === 'edit' ? 'SUBJECTS.EDIT_TITLE' : 'SUBJECTS.ADD_TITLE') | translate) }}</h3>
      <button type="button" class="btn btn-ghost btn-icon" (click)="closeModal()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <div class="modal-body">
      <div class="alert alert-error" *ngIf="isError">{{ errorMessage | translate }}</div>
      <form [formGroup]="form" (ngSubmit)="submit()">
        <div class="form-field">
          <label for="subjectName">{{ 'COMMON.NAME' | translate }}</label>
          <input id="subjectName" type="text" formControlName="name" />
          <span class="error" *ngIf="form.get('name')?.touched && form.get('name')?.hasError('required')">
            {{ 'COMMON.NAME_REQUIRED' | translate }}
          </span>
        </div>
      </form>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="closeModal()">
        {{ (mode === 'view' ? 'COMMON.CLOSE' : 'COMMON.CANCEL') | translate }}
      </button>
      <button type="button" class="btn btn-primary" *ngIf="mode !== 'view'" (click)="submit()">
        {{ 'COMMON.SAVE' | translate }}
      </button>
    </div>
  </div>
</div>
